/**
 * `schemaExtender` do `ObjectListWidget`: torna `alt` obrigatório apenas quando
 * o editor envia imagem própria (`data.image`). Sem imagem própria, o card
 * herda a imagem — e o texto alternativo (`descricaoImagem`) — do conteúdo
 * referenciado, então exigir ALT aqui duplicaria dado. Ver o render em
 * `components/View/CapaView/helpers.ts`.
 */
type ItemSchema = { required?: string[]; [key: string]: unknown };
type ItemData = { image?: unknown; [key: string]: unknown };

export const requireAltWhenOwnImage = (
  schema: ItemSchema,
  data: ItemData,
): ItemSchema => {
  const hasOwnImage = Array.isArray(data?.image)
    ? data.image.length > 0
    : Boolean(data?.image);
  const required = schema.required ?? [];
  if (!hasOwnImage || required.includes('alt')) return schema;
  return { ...schema, required: [...required, 'alt'] };
};

export default requireAltWhenOwnImage;
